/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CaseListResponse } from '../../models/case-list-response';
import { CasesRequest } from '../../models/cases-request';

export interface GetCases$Params {
      body: CasesRequest
}

export function getCases(http: HttpClient, rootUrl: string, params: GetCases$Params, context?: HttpContext): Observable<StrictHttpResponse<CaseListResponse>> {
  const rb = new RequestBuilder(rootUrl, getCases.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CaseListResponse>;
    })
  );
}

getCases.PATH = '/api/v1/cases-request';
